
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class EmptyTableRow extends Vue {
    @Prop({default: 100, type: Number}) readonly colSpan!: number;
  }
